import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { prorrateoApi } from "@/features/prorrateo/services/prorrateo.api";

/**
 * Single source of truth para el query del prorrateo · usado por el
 * loader de la ruta (para `ensureQueryData`) y por el componente
 * (`useSuspenseQuery`). Compartir el descriptor evita duplicar la
 * config (queryKey, fn, staleTime) y mantiene cache coherente.
 */
export const prorrateoQueryOptions = (solicitudId: string) =>
  queryOptions({
    queryKey: qk.prorrateo(solicitudId),
    queryFn: () => prorrateoApi.obtener(solicitudId),
    staleTime: 30_000,
  });

export function useProrrateo(solicitudId: string) {
  return useSuspenseQuery(prorrateoQueryOptions(solicitudId));
}
